import React, { useState, useEffect } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  ListItemAvatar,
  TextField,
  Avatar,
  Tooltip,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider,
  Grid,
  ListSubheader,
  Menu,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import DriveFileMoveIcon from "@mui/icons-material/DriveFileMove";
import DeleteIcon from "@mui/icons-material/Delete";
import CreateEditLayout from "./Dialogs/CreateEditLayout";
import {
  getGroupedLayoutsByUser,
  createLayout,
  deleteLayout,
  changeLayoutGroup,
} from "../../services/Layouts";
import { getGroupsByUser } from "../../services/Groups";

export default function GroupList() {
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [layoutId, setLayoutId] = useState(0);
  const [layoutName, setLayoutName] = useState("");
  const [layoutIcon, setLayoutIcon] = useState("");
  const [newLayoutName, setNewLayoutName] = useState("");
  const [layoutRegisters, setLayoutRegisters] = useState({});
  const [groupedLayouts, setGroupedLayouts] = useState(null);
  const [groups, setGroups] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(0);
  const [errorNewLayoutName, setErrorNewLayoutName] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const openGroupMenu = Boolean(anchorEl);

  useEffect(() => {
    /*     setGroupedLayouts([
      {
        group_name: "cielo",
        group_id: 1,
        layouts: [
          {
            name: "teste",
            id: 1,
            icon: "item.icon",
            registers: {
              0: {
                name: "Header",
                fields: [
                  {
                    name: "Estabelecimento Matriz",
                    index: 2,
                    size: 10,
                  },
                  {
                    name: "Adquirente",
                    index: 43,
                    size: 5,
                  },
                  {
                    name: "Versao Layout",
                    index: 71,
                    size: 3,
                  },
                ],
              },
              1: {
                name: "Resumo Operações",
                fields: [
                  {
                    name: "TipoRegistro",
                    index: 1,
                    size: 1,
                  },
                  {
                    name: "EstabelecimentoSubmissor",
                    index: 2,
                    size: 10,
                  },
                  {
                    name: "NumeroRo",
                    index: 12,
                    size: 7,
                  },
                  {
                    name: "Parcela",
                    index: 19,
                    size: 2,
                  },
                  {
                    name: "Filler",
                    index: 21,
                    size: 1,
                  },
                  {
                    name: "Plano",
                    index: 22,
                    size: 2,
                  },
                  {
                    name: "TipoTransacao",
                    index: 24,
                    size: 2,
                    type: "number",
                  },
                  {
                    name: "DataApresentacao",
                    index: 26,
                    size: 6,
                    type: "date yymmdd",
                  },
                  {
                    name: "DataPrevistaPagamento",
                    index: 32,
                    size: 6,
                    type: "date yymmdd",
                  },
                  {
                    name: "DataEnvioBanco",
                    index: 38,
                    size: 6,
                    type: "date yymmdd",
                  },
                  {
                    name: "SinalVlrBruto",
                    index: 44,
                    size: 1,
                  },
                  {
                    name: "VlrBruto",
                    index: 45,
                    size: 13,
                    type: "number",
                  },
                  {
                    name: "SinalComissao",
                    index: 58,
                    size: 1,
                  },
                  {
                    name: "VlrComissao",
                    index: 59,
                    size: 13,
                    type: "number",
                  },
                  {
                    name: "SinalVlrRejeitado",
                    index: 72,
                    size: 1,
                  },
                  {
                    name: "VlrRejeitado",
                    index: 73,
                    size: 13,
                    type: "number",
                  },
                  {
                    name: "SinalVlrLiquido",
                    index: 86,
                    size: 1,
                  },
                  {
                    name: "VlrLiquido",
                    index: 87,
                    size: 13,
                    type: "number",
                  },
                  {
                    name: "Banco",
                    index: 100,
                    size: 4,
                  },
                  {
                    name: "Agencia",
                    index: 104,
                    size: 5,
                  },
                  {
                    name: "ContaCorrente",
                    index: 109,
                    size: 14,
                  },
                  {
                    name: "StatusPagamento",
                    index: 123,
                    size: 2,
                    type: "number",
                  },
                  {
                    name: "QuantidadeCvsAceitos",
                    index: 125,
                    size: 6,
                    type: "number",
                  },
                  {
                    name: "OldIdtProduto",
                    index: 131,
                    size: 2,
                  },
                  {
                    name: "QuantidadesCvsRejeitados",
                    index: 133,
                    size: 6,
                    type: "number",
                  },
                  {
                    name: "IdtAceleracao",
                    index: 139,
                    size: 1,
                  },
                  {
                    name: "DataCapturaTransacao",
                    index: 140,
                    size: 6,
                    type: "date yymmdd",
                  },
                  {
                    name: "OrigemAjuste",
                    index: 146,
                    size: 2,
                  },
                  {
                    name: "ValorComplementar",
                    index: 148,
                    size: 13,
                    type: "number",
                  },
                  {
                    name: "IdtProdutoFinanceiro",
                    index: 161,
                    size: 1,
                  },
                  {
                    name: "NumeroOperacaoFinanceira",
                    index: 162,
                    size: 9,
                    type: "number",
                  },
                  {
                    name: "SinalVlrBrutoAntecipado",
                    index: 171,
                    size: 1,
                  },
                  {
                    name: "VlrBrutoAntecipado",
                    index: 172,
                    size: 13,
                    type: "number",
                  },
                  {
                    name: "CodigoBandeira",
                    index: 185,
                    size: 3,
                    type: "number",
                  },
                  {
                    name: "NumeroUnicoRo",
                    index: 188,
                    size: 22,
                  },
                  {
                    name: "TaxaComissao",
                    index: 210,
                    size: 4,
                  },
                  {
                    name: "Tarifa",
                    index: 214,
                    size: 5,
                  },
                  {
                    name: "TaxaGarantia",
                    index: 219,
                    size: 4,
                  },
                  {
                    name: "MeioCaptura",
                    index: 223,
                    size: 2,
                  },
                  {
                    name: "NumeroLogicoTerminal",
                    index: 225,
                    size: 8,
                  },
                  {
                    name: "IdtProduto",
                    index: 233,
                    size: 3,
                  },
                  {
                    name: "MatrizPagamento",
                    index: 236,
                    size: 10,
                  },
                  {
                    name: "ReenvioPagamento",
                    index: 246,
                    size: 1,
                  },
                  {
                    name: "Conceito",
                    index: 247,
                    size: 1,
                  },
                  {
                    name: "GrupoCartoes",
                    index: 248,
                    size: 2,
                  },
                  {
                    name: "UsoCielo",
                    index: 250,
                    size: 1,
                  },
                  {
                    name: "DataVencimentoOriginal",
                    index: 38,
                    size: 6,
                    type: "date yymmdd",
                  },
                  {
                    name: "IndicadorRecebaRapido",
                    index: 131,
                    size: 1,
                  },
                  {
                    name: "IndicadorTaxaMinima",
                    index: 132,
                    size: 1,
                  },
                  {
                    name: "TaxaRecebaRapido",
                    index: 219,
                    size: 4,
                  },
                  {
                    name: "IndicadorSaldoEmAberto",
                    index: 250,
                    size: 1,
                  },
                  {
                    name: "IdtRo",
                    index: 188,
                    size: 15,
                  },
                ],
              },
              2: {
                name: "Comprovante Venda",
                fields: [
                  {
                    name: "TipoRegistro",
                    index: 1,
                    size: 1,
                  },
                  {
                    name: "EstabelecimentoSubmissor",
                    index: 2,
                    size: 10,
                  },
                  {
                    name: "NumeroRo",
                    index: 12,
                    size: 7,
                    type: "number",
                  },
                  {
                    name: "NumeroCartao",
                    index: 19,
                    size: 19,
                  },
                  {
                    name: "DataVenda",
                    index: 38,
                    size: 8,
                    type: "date yyyymmdd",
                  },
                  {
                    name: "SinalVlrCompra",
                    index: 46,
                    size: 1,
                  },
                  {
                    name: "VlrCompra",
                    index: 47,
                    size: 13,
                    type: "number",
                  },
                  {
                    name: "Parcela",
                    index: 60,
                    size: 2,
                    type: "number",
                  },
                  {
                    name: "TotalParcelas",
                    index: 62,
                    size: 2,
                    type: "number",
                  },
                  {
                    name: "MotivoRejeicao",
                    index: 64,
                    size: 3,
                  },
                  {
                    name: "CodigoAutorizacao",
                    index: 67,
                    size: 6,
                  },
                  {
                    name: "Tid",
                    index: 73,
                    size: 20,
                  },
                  {
                    name: "Nsu",
                    index: 93,
                    size: 6,
                  },
                  {
                    name: "ValorComplementar",
                    index: 99,
                    size: 13,
                    type: "number",
                  },
                  {
                    name: "Cartao",
                    index: 112,
                    size: 2,
                    type: "number",
                  },
                  {
                    name: "ValorTotalVenda",
                    index: 114,
                    size: 13,
                    type: "number",
                  },
                  {
                    name: "ValorProximaParcela",
                    index: 127,
                    size: 13,
                    type: "number",
                  },
                  {
                    name: "NumeroNotaFiscal",
                    index: 140,
                    size: 9,
                    type: "number",
                  },
                  {
                    name: "IdtCartaoEmitidoExterior",
                    index: 149,
                    size: 4,
                    type: "number",
                  },
                  {
                    name: "NumeroTerminal",
                    index: 153,
                    size: 8,
                  },
                  {
                    name: "IdtTransacao",
                    index: 161,
                    size: 2,
                  },
                  {
                    name: "Referencia",
                    index: 163,
                    size: 20,
                  },
                  {
                    name: "HoraTransacao",
                    index: 183,
                    size: 6,
                  },
                  {
                    name: "NumeroUnicoTransacao",
                    index: 189,
                    size: 29,
                  },
                  {
                    name: "IdtCieloPremia",
                    index: 218,
                    size: 1,
                  },
                  {
                    name: "ModoEntradaCartao",
                    index: 219,
                    size: 2,
                  },
                  {
                    name: "Transacao",
                    index: 221,
                    size: 15,
                  },
                  {
                    name: "AgrupamentoAjuste",
                    index: 236,
                    size: 15,
                  },
                  {
                    name: "IdtRo",
                    index: 189,
                    size: 15,
                  },
                ],
              },
            },
          },
        ],
      },
    ]); */
    getGroups();
    getLayouts();
  }, []);

  const handleClickChangeGroup = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseGroupMenu = () => {
    setAnchorEl(null);
  };

  const handleOpenDeleteDialog = (layoutId) => {
    setLayoutId(layoutId);
    setOpenDeleteDialog(true);
  };

  const handleConfirmDelete = () => {
    deleteLayout({ layoutId }).then((response) => {
      getLayouts();
    });
    setOpenDeleteDialog(false);
  };

  const handleChangeLayoutGroup = (groupId) => {
    handleCloseGroupMenu();
    changeLayoutGroup({ layoutId, groupId }).then(() => {
      getLayouts();
    });
  };

  const handleCreateLayout = () => {
    if (!newLayoutName) {
      setErrorNewLayoutName(true);
    } else {
      createLayout({
        name: newLayoutName,
        groupId: selectedGroup,
      })
        .then((response) => {
          getLayouts();
          const content = JSON.parse(
            '{"name":"' + newLayoutName + '","icon":"","registers":{}}',
          );
          handleOpenEditDialog(response.layoutId, newLayoutName, "", content);
        })
        .catch((error) => {
          //
        });
    }
  };
  const getGroups = () => {
    getGroupsByUser()
      .then((response) => {
        setGroups(response.data);
      })
      .catch((error) => {
        //
      });
  };
  const getLayouts = () => {
    getGroupedLayoutsByUser()
      .then((data) => {
        setGroupedLayouts(data.data);
      })
      .catch((e) => {});
  };

  const handleSelectGroup = (event) => {
    setSelectedGroup(event.target.value);
  };

  const handleOpenEditDialog = (id, name, icon, content) => {
    setLayoutId(id);
    setLayoutName(name);
    setLayoutIcon(icon);
    //setLayoutRegisters(registers);
    setLayoutRegisters(content.registers);
    setOpenEditDialog(true);
  };

  return (
    <>
      <Box pt={2}>
        {groupedLayouts &&
          groupedLayouts.map((group) => (
            <>
              <Accordion key={group.group_name}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  {group.group_name === "__dg_" ? (
                    <Typography variant="caption" color={"#7f7f7f"}>
                      {"LAYOUTS SEM GRUPO"}
                      {/*trad */}
                    </Typography>
                  ) : (
                    <Typography variant="body2">{group.group_name}</Typography>
                  )}
                </AccordionSummary>
                <AccordionDetails>
                  <List>
                    {group?.layouts?.map((layout) => (
                      <ListItem
                        key={layout.id}
                        secondaryAction={
                          <Box sx={{ display: "flex", gap: 1.5 }}>
                            <Tooltip title="Editar layout">
                              {/*trad */}
                              <IconButton
                                aria-label="edit"
                                onClick={() =>
                                  handleOpenEditDialog(
                                    layout.id,
                                    layout.name,
                                    layout.icon,
                                    layout.content,
                                  )
                                }
                              >
                                <EditIcon />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Excluir layout">
                              {/*trad */}
                              <IconButton
                                aria-label="delete"
                                onClick={() =>
                                  handleOpenDeleteDialog(layout.id)
                                }
                              >
                                {/*trad */}
                                <DeleteIcon />
                              </IconButton>
                            </Tooltip>

                            <IconButton
                              onClick={(e) => {
                                handleClickChangeGroup(e);
                                setLayoutId(layout.id);
                              }}
                            >
                              <DriveFileMoveIcon />
                            </IconButton>
                            <Menu
                              anchorEl={anchorEl}
                              open={openGroupMenu}
                              onClose={handleCloseGroupMenu}
                            >
                              <ListSubheader>
                                TROCAR GRUPO DO LAYOUT{/* trad */}
                              </ListSubheader>

                              {groups &&
                                groups.map(
                                  (group) =>
                                    group.name !== "__dg_" && (
                                      <MenuItem
                                        key={group.id}
                                        onClick={() => {
                                          handleChangeLayoutGroup(group.id);
                                        }}
                                      >
                                        {group.name}
                                      </MenuItem>
                                    ),
                                )}
                              <Divider />
                              <MenuItem
                                onClick={() => handleChangeLayoutGroup(1)}
                              >
                                Deixar sem grupo{/* trad */}
                              </MenuItem>
                            </Menu>
                          </Box>
                        }
                      >
                        <ListItemAvatar>
                          <Avatar
                            src={layout.icon}
                            variant="rounded"
                            sx={{ width: 32, height: 32 }}
                          />
                        </ListItemAvatar>
                        <ListItemText primary={layout.name} />
                      </ListItem>
                    ))}
                  </List>
                </AccordionDetails>
              </Accordion>
            </>
          ))}
      </Box>
      <Box pt={2}>
        <Grid container spacing={2}>
          <Grid item xs={5}>
            <TextField
              fullWidth
              label="Nome do Layout"
              /*trad */ variant="outlined"
              size="small"
              onChange={(e) => {
                setNewLayoutName(e.target.value);
                setErrorNewLayoutName(false);
              }}
              error={errorNewLayoutName}
              helperText={
                errorNewLayoutName && "Insira um nome para o layout" /*trad */
              }
            />
          </Grid>
          <Grid item xs={3}>
            <FormControl fullWidth size="small">
              <InputLabel id="group">Grupo</InputLabel>
              <Select
                labelId="group"
                id="group-select"
                value={selectedGroup}
                label="Grupo" /*trad */
                onChange={handleSelectGroup}
              >
                {groups &&
                  groups.map(
                    (group) =>
                      group.name !== "__dg_" && (
                        <MenuItem key={group.id} value={group.id}>
                          {group.name}
                        </MenuItem>
                      ),
                  )}
                <Divider />
                <MenuItem key={1} value={1}>
                  Criar sem grupo
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={4}>
            <Button
              variant="contained"
              onClick={(e) => handleCreateLayout(e.target.value)}
              startIcon={<AddIcon />}
            >
              {/*trad */}Adicionar layout
            </Button>
          </Grid>
        </Grid>
      </Box>

      <Dialog
        open={openDeleteDialog}
        onClose={() => setOpenDeleteDialog(false)}
      >
        <DialogTitle>Confirmar Exclusão</DialogTitle>
        <DialogContent>
          <Typography>
            Tem certeza que deseja excluir o layout?{/* *trad */}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDeleteDialog(false)}>
            Cancelar{/* trad */}
          </Button>
          <Button
            onClick={() => handleConfirmDelete()}
            color="error"
            variant="contained"
          >
            Excluir{/* trad */}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openEditDialog}
        onClose={() => setOpenEditDialog(false)}
        maxWidth={"lg"}
        PaperProps={{
          sx: {
            width: 1200,
          },
        }}
        style={{ zIndex: "999999" }}
      >
        <CreateEditLayout
          layoutId={layoutId}
          layoutRegisters={layoutRegisters}
          layoutName={layoutName}
          layoutIcon={layoutIcon}
          setOpenEditDialog={setOpenEditDialog}
          getLayouts={getLayouts}
        />
      </Dialog>
    </>
  );
}
